import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { RecurringMeeting } from 'Shared/constants/types';

import ContentWrapper from '../Wrappers/ContentWrapper/ContentWrapper';
import { WorkspacesType } from '../../types';
import FormFields from './FormFields/FormFields';
import { getInitialInviteeEmails, outputWorkspacesDecorator } from './utils';

const defaultPersonalMessage = 'Hi Team, I’m trying out a tool called Perform that helps us have better  meetings.';

type Props = {
  workspaces: WorkspacesType;
  advanceOnboardingState: Function;
  recurringMeetings: Array<RecurringMeeting>;
};

function InviteTeammates({
  workspaces: initWorkspaces,
  recurringMeetings: initRecurringMeetings,
  advanceOnboardingState,
}: Props) {
  const currentUserEmail = useSelector(state => state.user.email);
  const handleNextStep = useCallback(
    ({ inviteeEmails, personalMessage }) => {
      return advanceOnboardingState({
        workspaces: outputWorkspacesDecorator({
          workspaces: initWorkspaces,
          inviteeEmails: inviteeEmails.filter(({ selected }) => selected).map(({ email }) => email),
          recurringMeetings: initRecurringMeetings,
          personalMessage,
        }),
      });
    },
    [advanceOnboardingState, initRecurringMeetings, initWorkspaces]
  );

  return (
    <ContentWrapper
      initialValues={{
        inviteeEmails: getInitialInviteeEmails({
          recurringMeetings: initRecurringMeetings,
          workspaces: initWorkspaces,
          currentUserEmail,
        }),
        personalMessage: initWorkspaces[0]?.personalMessage || defaultPersonalMessage,
      }}
      title="Invite your teammates"
      description="Here are the attendees for the meetings you selected. Invite them now!"
      mutedDescription
      onNextStep={handleNextStep}
    >
      <FormFields />
    </ContentWrapper>
  );
}

export default InviteTeammates;
